/* eslint-disable sonarjs/cognitive-complexity */
const COMPOSITE_TYP_LABEL = 'composite';
const BACKGROUND_COMPOSITE = 'background';
const CTA_BG_IMAGE_KEY_LABEL = 'ctaBackgroundImage';
const BORDER_SUB_LABEL = 'border';
const CTA_ITEM_SUB_LABEL = 'ctaItem';
const BYPASS_ARRAY_ITEM_LIST = ['category'];
const COLUMN_TYP_LABEL = 'col';
const LARGE_COMP_IMAGE_SUB_LABEL = 'largeCompImage';
const BACKGROUND_COLOR_SUB_LABEL = 'backgroundColor';
const SUBMODULE_TYP_LABEL = 'submodule';
const BORDER = 'border';
const BACKGROUND = 'background';
const COLUMN_NAME = 'colName';

const flat = (list, flattend) => {
  list.forEach((el) => {
    if (Array.isArray(el)) {
      flat(el, flattend);
    } else {
      flattend.push(el);
    }
  });
  return flattend;
};

export const flattenArray = (array) => {
  const flattend = [];
  flat(array, flattend);
  return flattend;
};

export const processBorder = (border) => {
  const newBorder = {};
  const config = {};
  const construct = {};

  newBorder.type = border.typ;
  newBorder.name = border.sub;

  // constructing config
  if (border.set && Array.isArray(border.set)) {
    border.set.forEach((item) => {
      config[item.key] = item.val;
    });
  }
  newBorder.config = config;

  // constructing construct
  const borderValObj = border.val && border.val.val;
  // check if subtype is not present at root (border.val)
  if (borderValObj && border.val && !border.val.sub) {
    Object.keys(borderValObj).forEach((key) => {
      const borderKeyValObj = borderValObj[key] && borderValObj[key].val;
      if (borderKeyValObj && borderValObj[key].val.sub) {
        const subType = borderKeyValObj.sub;
        construct[key] = {};
        construct[key].type = subType;
        construct[key][subType] = borderKeyValObj.val;
      } else {
        // check if (border.val.val) is an array
        const multiValConfig = [];
        const multiValObj = borderValObj[key] && borderKeyValObj && Array.isArray(borderKeyValObj);
        if (multiValObj) {
          borderKeyValObj.forEach((item) => {
            multiValConfig.push(item.val);
          });
        }
        construct[key] = {
          type: borderValObj[key] && borderValObj[key].sub,
        };
        const subType = borderValObj[key].sub;
        construct[key][subType] = multiValObj ? multiValConfig : borderValObj[key].val;
      }
    });
  }

  const borderValSub = border.val && border.val.sub;
  if (borderValSub) {
    const subType = borderValSub;
    construct.type = borderValSub;
    construct[subType] = border.val.val;
  }

  newBorder.construct = construct;
  return newBorder;
};

export const processCompositeVal = ({
  composite,
  arrTypes,
  transformedComposite,
  transformComposite,
  compositeVal,
  compositeCtaBgImg,
  isCtaItem,
}) => {
  /* eslint-disable no-param-reassign */
  composite.val.forEach((data) => {
    if (data.typ === COMPOSITE_TYP_LABEL) {
      if (Array.isArray(data.val)) {
        arrTypes.push(data.sub);
        transformedComposite = transformComposite(data, false);
        const tranformedCompositeKeys = Object.keys(transformedComposite);
        tranformedCompositeKeys.forEach((key) => {
          if (!compositeVal[data.sub]) {
            compositeVal[data.sub] = [];
          }
          compositeVal[data.sub].push(transformedComposite[key]);
        });
      } else if (data.sub === BACKGROUND_COMPOSITE && data.val.sub) {
        compositeVal[data.sub] = {};
        compositeVal[data.sub][data.val.sub] = data.val.val;
      } else {
        compositeVal[data.sub] = data.val.val;
        if (data && data.bgimg) {
          compositeVal[data.sub][CTA_BG_IMAGE_KEY_LABEL] = data.bgimg.val.val;
        }
      }
    } else if (Array.isArray(compositeVal[data.sub])) {
      compositeVal[data.sub].push(data.val);
    } else if (data.sub === BORDER_SUB_LABEL) {
      compositeVal[data.sub] = processBorder(data);
    } else {
      compositeVal[data.sub] = isCtaItem ? data.val : [data.val];
    }
    if (Array.isArray(compositeVal[data.sub])) {
      compositeVal[data.sub] = flattenArray(compositeVal[data.sub]);
    }
  });

  if (compositeVal[CTA_ITEM_SUB_LABEL] && compositeCtaBgImg) {
    const ctaObj = compositeVal[CTA_ITEM_SUB_LABEL];
    const ctaBgImageObj = {};

    ctaBgImageObj[CTA_BG_IMAGE_KEY_LABEL] = compositeCtaBgImg.val.val;
    ctaObj.push(ctaBgImageObj);
  }

  if (compositeVal[CTA_ITEM_SUB_LABEL] && !compositeCtaBgImg) {
    const ctaBgImgObj = composite.val[0].bgimg;
    const ctaColObj = compositeVal[CTA_ITEM_SUB_LABEL];
    if (ctaBgImgObj && ctaColObj) {
      const ctaColBgImageObj = {};

      ctaColBgImageObj[CTA_BG_IMAGE_KEY_LABEL] = ctaBgImgObj.val.val;
      ctaColObj.push(ctaColBgImageObj);
    }
  }
  /* eslint-enable no-param-reassign */
};

export const transformComposite = (composite, topLevel) => {
  const finalTransformedComposite = {};
  let transformedComposite;
  const compositeSet = composite.set;
  const compositeCtaBgImg = composite && composite.bgimg;
  const compositeSetVal = {};
  let compositeVal = {};
  const arrTypes = [];
  const compInstances = {};
  const isCtaItem = composite.sub === CTA_ITEM_SUB_LABEL;
  const isLargeCompImage = composite.sub === LARGE_COMP_IMAGE_SUB_LABEL;
  const isBackgroundColorImg = composite.sub === BACKGROUND_COLOR_SUB_LABEL;

  composite.val.forEach((item) => {
    if (compInstances[item.sub]) {
      compInstances[item.sub] += 1;
    } else {
      compInstances[item.sub] = 1;
    }
  });

  if (compositeSet && Array.isArray(compositeSet)) {
    compositeSet.forEach((item) => {
      compositeSetVal[item.key] = item.val;
    });
  }

  processCompositeVal({
    composite,
    arrTypes,
    transformedComposite,
    transformComposite,
    compositeVal,
    compositeCtaBgImg,
    isCtaItem,
  });

  Object.keys(compositeVal).forEach((key) => {
    if (
      Object.keys(compInstances).length > 1 &&
      compositeVal[key].length === 1 &&
      (arrTypes.indexOf(key) === -1 || Array.isArray(compositeVal[key][0])) &&
      !BYPASS_ARRAY_ITEM_LIST.includes(key)
    ) {
      [compositeVal[key]] = compositeVal[key];
    }
  });

  if (Object.keys(compositeVal).length === 1) {
    if (
      !(isCtaItem && !Array.isArray(compositeVal[Object.keys(compositeVal)[0]])) &&
      !isLargeCompImage &&
      !isBackgroundColorImg
    ) {
      compositeVal = compositeVal[Object.keys(compositeVal)[0]];
    }
    if (isBackgroundColorImg) {
      const backgroundColorObj = {};

      const [objKey, objValue] = [Object.keys(compositeVal)[0], Object.values(compositeVal)[0][0]];

      backgroundColorObj[objKey] = objValue;

      compositeVal = backgroundColorObj;
    }
  }

  if (!Array.isArray(compositeVal) && topLevel) {
    compositeVal = [compositeVal];
  }

  if (Object.keys(compositeSetVal).length) {
    if (Array.isArray(compositeVal)) {
      compositeVal = compositeVal.map((comp) => ({ ...comp, ...compositeSetVal }));
    } else {
      Object.assign(compositeVal, { ...compositeSetVal });
    }
  }

  finalTransformedComposite[composite.sub] = compositeVal;
  return finalTransformedComposite;
};

export const processCompositeValueList = ({ moduleData, transformedComposite, key }) => {
  if (moduleData.composites[key]) {
    if (Array.isArray(moduleData.composites[key])) {
      moduleData.composites[key].push(transformedComposite[key]);
    } else {
      /* eslint-disable-next-line no-param-reassign */
      moduleData.composites[key] = [moduleData.composites[key], transformedComposite[key]];
    }
  } else {
    Object.assign(moduleData.composites, transformedComposite);
  }
};

export const processComposite = (data, moduleData, topLevel) => {
  let transformedComposite;
  if (data.typ === COMPOSITE_TYP_LABEL && Array.isArray(data.val)) {
    transformedComposite = transformComposite(data, topLevel);
    const key = Object.keys(transformedComposite)[0];
    if (Array.isArray(transformedComposite[key])) {
      transformedComposite[key] = flattenArray(transformedComposite[key]);
    }
    processCompositeValueList({ moduleData, transformedComposite, key });
  } else {
    /* eslint-disable-next-line no-param-reassign */
    moduleData.composites[data.sub] = data.val.val;
    if (typeof data.val.val === 'undefined') {
      /* eslint-disable-next-line no-param-reassign */
      moduleData.composites[data.sub] = data.val;
    }
  }
};

export const processColumnMedia = (columnMedia, columnConfig, key) => {
  const { set, val } = columnMedia;

  if (!columnConfig[key]) {
    // eslint-disable-next-line no-param-reassign
    columnConfig[key] = {};
  }
  if (set && Array.isArray(set)) {
    // eslint-disable-next-line no-param-reassign
    columnConfig[key].set = set;
  }

  if (val) {
    // eslint-disable-next-line no-param-reassign
    columnConfig[key][val.sub] = val.val;
  }
};

export const processColumns = (data, moduleData) => {
  const { val: columnVals, set: columnSet, bor: columnBorder, bmc: columnBackground } = data;
  const columnConfig = {};
  if (!moduleData.allColumns) {
    // eslint-disable-next-line no-param-reassign
    moduleData.allColumns = [];
  }
  if (!moduleData.ctaOnlyColumn) {
    // eslint-disable-next-line no-param-reassign
    moduleData.ctaOnlyColumn = [];
  }
  if (!moduleData.columns) {
    // eslint-disable-next-line no-param-reassign
    moduleData.columns = [];
  }
  if (columnSet && Array.isArray(columnSet)) {
    columnConfig.set = columnSet;
  }
  if (columnVals && Array.isArray(columnVals)) {
    columnVals.forEach((columnVal) => {
      if (columnVal.typ === COMPOSITE_TYP_LABEL) {
        if (!columnConfig.composites) {
          columnConfig.composites = {};
        }
        if (columnVal.sub in columnConfig.composites) {
          processComposite(columnVal, columnConfig);
        } else {
          processComposite(columnVal, columnConfig, true);
        }
      } else {
        columnConfig[columnVal.sub] = columnVal.val;
      }
    });
  }
  if (columnBorder) {
    processColumnMedia(columnBorder, columnConfig, BORDER);
  }
  if (columnBackground) {
    processColumnMedia(columnBackground, columnConfig, BACKGROUND);
  }
  const { val: columnName } = columnConfig.set.find((elm) => {
    if (elm.key === COLUMN_NAME) {
      return elm.val;
    }
    return '';
  });

  const allColumnsObj = Object.assign({}, { [columnName]: columnConfig });
  const lastColObj = Object.keys(allColumnsObj).toString() === 'column_5' && columnConfig;
  const remainingColObj = Object.keys(allColumnsObj).toString() !== 'column_5' && columnConfig;
  // eslint-disable-next-line no-unused-expressions
  remainingColObj && moduleData.allColumns.push(remainingColObj);
  // eslint-disable-next-line no-unused-expressions
  lastColObj && moduleData.ctaOnlyColumn.push(lastColObj);
  moduleData.columns.push(columnConfig);
};

export const transformCMSModuleData = (apiData) => {
  const moduleData = {};
  const setData = {};
  const jsonData = { ...apiData };
  const returnData = {};

  moduleData.contentId = jsonData.cid;
  moduleData.name = jsonData.sub;
  moduleData.type = jsonData.typ;
  moduleData.composites = {};
  moduleData.submodules = {};

  if (!Array.isArray(jsonData.val)) {
    jsonData.val = [jsonData.val];
  }
  if (jsonData.set && Array.isArray(jsonData.set)) {
    jsonData.set.forEach((item) => {
      setData[item.key] = item.val;
    });
  }
  jsonData.val.forEach((data) => {
    if (data) {
      if (data.typ === SUBMODULE_TYP_LABEL) {
        moduleData.submodules[data.sub] = { composites: {} };
        data.val.forEach((composite) =>
          processComposite(composite, moduleData.submodules[data.sub], true)
        );
      } else if (data.typ === COLUMN_TYP_LABEL) {
        processColumns(data, moduleData);
      } else {
        processComposite(data, moduleData, true);
      }
    }
  });

  const transformedSet = {};
  jsonData.set.forEach(({ key, val }) => {
    transformedSet[key] = val;
  });

  Object.assign(
    returnData,
    { ...moduleData.composites },
    { moduleName: moduleData.name },
    { set: jsonData.set },
    { allColumns: moduleData.allColumns || [] },
    { ctaOnlyColumn: moduleData.ctaOnlyColumn || [] },
    { ...transformedSet }
  );

  return returnData;
};
